import { motion, Transition, Variants } from "motion/react"

const EYE_REST_D =
  "M303.316 138C303.316 138 258.851 195.343 204 195.343C149.149 195.343 104.684 138 104.684 138C104.684 138 149.149 80.6562 204 80.6562C258.851 80.6562 303.316 138 303.316 138Z"
const EYE_HOVER_D =
  "M293.043 138C293.043 138 253.176 161.43 203.998 161.43C154.82 161.43 114.953 138 114.953 138C114.953 138 154.82 114.571 203.998 114.571C253.176 114.571 293.043 138 293.043 138Z"

const PUPIL_REST_R = 38.041
const PUPIL_HOVER_R = 32.97

// Slight overshoot past the squinted target before settling, matching the
// bounce used on the other tool animations.
const OVERSHOOT_RATIO = 0.2
const bounceNumber = (start: number, end: number) => [start, end + (end - start) * OVERSHOOT_RATIO, end]

const NUMBER = /-?\d+(\.\d+)?/g

// The eye outline is authored as two same-shaped paths (same command
// sequence, same count of numbers) - overshooting means nudging each number
// in the end path further from its start value by the same ratio, so the
// shape briefly overshoots the squint before easing back to it.
function bouncePath(startD: string, endD: string) {
  const startNums = startD.match(NUMBER)!.map(Number)
  const endNums = endD.match(NUMBER)!.map(Number)
  let i = 0
  const overshootD = endD.replace(NUMBER, () => {
    const value = endNums[i] + (endNums[i] - startNums[i]) * OVERSHOOT_RATIO
    i++
    return String(value)
  })
  return [startD, overshootD, endD]
}

const bounceTransition: Transition = { duration: 0.3, ease: "easeOut", times: [0, 0.3, 1] }

const eyeVariants: Variants = {
  rest: { d: EYE_REST_D },
  hover: { d: bouncePath(EYE_REST_D, EYE_HOVER_D), transition: bounceTransition },
}

const pupilVariants: Variants = {
  rest: { r: PUPIL_REST_R },
  hover: { r: bounceNumber(PUPIL_REST_R, PUPIL_HOVER_R), transition: bounceTransition },
}

export const ManageFatigueAnimation = ({ hover }: { hover?: boolean }) => (
  <motion.div
    initial="rest"
    animate={hover ? "hover" : "rest"}
    className="w-full aspect-[41/28] relative [&_svg]:absolute [&_svg]:w-full [&_svg]:h-auto overflow-hidden"
  >
    <svg width="408" height="276" viewBox="0 0 408 276" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2872_43628)">
        <rect width="408" height="276" rx="6" fill="#222222" />
        <motion.path variants={eyeVariants} fill="#F3F3F3" />
        <path
          d="M204.066 90.9634C149.215 90.9634 104.75 148.307 104.75 148.307V-5.57275H303.383V148.307C303.383 148.307 258.917 90.9634 204.066 90.9634Z"
          fill="#222222"
        />
        <path
          d="M204.066 183.705C149.215 183.705 104.75 126.361 104.75 126.361V280.241H303.383V126.361C303.383 126.361 258.917 183.705 204.066 183.705Z"
          fill="#222222"
        />
        <motion.circle cx="204.064" cy="138.307" variants={pupilVariants} fill="#222222" />
        <rect x="11.5469" y="34.3813" width="101.57" height="209.013" fill="#222222" />
        <rect x="295.266" y="34.3813" width="101.57" height="209.013" fill="#222222" />
      </g>
      <defs>
        <clipPath id="clip0_2872_43628">
          <rect width="408" height="276" rx="6" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </motion.div>
)
